import { Link as LinkRouter } from 'react-router'
import styled from '@emotion/styled'
import { Header as HeaderFlipper } from 'flipper-ui'
import { theme } from 'flipper-ui/theme'

const { gray, neutral, primary } = theme.colors

export const Flex = styled.div`
    display: flex;
`

export const FlexColumn = styled(Flex)`
    flex-direction: column;
`

export const FlexItemsCenter = styled(Flex)`
    align-items: center;
`

export const FlexJustifyCenter = styled(Flex)`
    justify-content: center;
`

export const FlexExpanded = styled(Flex)`
    flex: 1;
`

export const FlexGrow = styled.div`
    flex: 1;
`

export const LoadingWrapper = styled.div`
    align-items: center;
    display: flex;
    height: 285px;
    justify-content: center;
`

export const AppBar = styled(HeaderFlipper)`
    z-index: 1200 !important;
    height: 56px;

    & > div {
        min-height: 56px;
    }
`

export const LogoImage = styled.img`
    cursor: pointer;
    height: 40px;
`

export const SubHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    top: 56px;
    z-index: 1100;
    position: sticky;
    padding: 16px 24px;
    background: ${neutral[100]};
    border-bottom: 1px solid ${gray[300]};
`

export const Wrapper = styled(FlexColumn)`
    align-items: center;
`

export const BreadcrumbLink = styled(LinkRouter)`
    text-decoration: none;
    color: ${primary.main};

    &:hover {
        text-decoration: underline;
    }
`
